import React, { FC } from 'react';
import { ImageButtonStyledAC } from './AC/ImageButtonStyled.AC';
import { ImageButtonStyledAP } from './AP/ImageButtonStyled.AP';
import { ImageButtonStyledDS } from './DS/ImageButtonStyled.DS';
import { ImageButtonStyledOV } from './OV/ImageButtonStyled.OV';
import { ImageButtonStyledOVGB } from './OV/GB/ImageButtonStyled.OV';
import { ImageButtonStyled } from './ImageButtonStyled';
import { SC } from '../../styles/theme';
import { getBrand } from '../../constants';
import { BrandTypes } from '../../types/brands';
import { isMarketGB } from '../../constants/main';

export interface IImageButtonProps extends SC {
    title: string;
    description: string;
    counter: number;
    imgUrl: string;
    href: string;
    usePxNotification?: boolean;
    alt?: string;
}

export const ImageButton: FC<IImageButtonProps> = (props: IImageButtonProps) => {
    if (getBrand() === BrandTypes.AC) return <ImageButtonStyledAC {...props} />;
    if (getBrand() === BrandTypes.AP) return <ImageButtonStyledAP {...props} />;
    if (getBrand() === BrandTypes.DS) return <ImageButtonStyledDS {...props} />;
    if (getBrand() === BrandTypes.OV)
        return isMarketGB ? <ImageButtonStyledOVGB {...props} /> : <ImageButtonStyledOV {...props} />;
    return <ImageButtonStyled {...props} />;
};
